import { Injectable } from '@angular/core';
import { ContextData } from 'src/app/data/context.data';

import jsPDF from 'jspdf';
import { Configuration } from 'src/app/data/configuration.data';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { SheetProperties } from 'src/app/data/configurator/sheet/sheet-properties.data';
import { TemplateData } from 'src/app/data/configurator/template/template.data';
import { TemplateLayoutData } from 'src/app/data/configurator/template/template-layout.data';
import { CoordUtil } from 'src/app/tools/coord.utils';


@Injectable()
export class PrintService {

  private _hPrintOffset:number;
  private _vPrintOffset:number;

  /**
   * Constructor
   */
  constructor() {
    this._vPrintOffset = localStorage.getItem('vPrintOffset') ? +localStorage.getItem('vPrintOffset') : 0;
    this._hPrintOffset = localStorage.getItem('hPrintOffset') ? +localStorage.getItem('hPrintOffset') : 0;
  }

  public print(configuration: Configuration, blankSheet: boolean): void {

    //console.log([configuration.sheetProperties.pixelsWidth * 72 / 300, configuration.sheetProperties.pixelsHeight * 72 / 300]);

    let doc = new jsPDF({
      unit: 'mm',
      orientation : configuration.sheetProperties.pixelsWidth < configuration.sheetProperties.pixelsHeight ? "portrait" : "landscape",
      format: [configuration.sheetProperties.pixelsWidth * 72 / 300, configuration.sheetProperties.pixelsHeight * 72 / 300],
      putOnlyUsedFonts: true
    });

    if (blankSheet) {
      this.setupNewPage(doc, configuration.sheetProperties);
    }

    for (var i: number = 0; i < configuration.labels.length; i++) {
      if (i > 0 && i % configuration.sheetProperties.layouts.length == 0) {
        if (blankSheet) this.drawBorders(doc, configuration);
        doc.addPage();
        if (blankSheet) this.setupNewPage(doc, configuration.sheetProperties);
      }


      let labelData: LabelData = configuration.labels[i];
      let layout: any = configuration.sheetProperties.layouts[i % configuration.sheetProperties.layouts.length];

      // console.log(layout, labelData);

      let rotationRad: number = -layout.rotation * Math.PI / 180;

      // because jsPdf rotation origin is bottomLeft
      let _offset = CoordUtil.rotate2D({x:0, y:-labelData.height},-layout.rotation);
      _offset.y += labelData.height;

        doc.addImage(
          labelData.label.preview,
          'JPEG',
          this.hPrintOffset + layout.x + _offset.x,
          this.vPrintOffset + layout.y - _offset.y ,
          labelData.width,
          labelData.height,
          "label" + i,
          'NONE',
          -layout.rotation
          );
    }

    if (blankSheet) this.drawBorders(doc, configuration);


    doc.save('Test.pdf');
  }

  drawBorders(doc:any, configuration: Configuration): void {
    // console.log(configuration);

    let sheetData = configuration.sheetProperties;

    let _borderOffset = 1 * ContextData.PIXELS_TO_MM;

    for (let i = 0; i < sheetData.layouts.length; i++) {
      let layout: TemplateLayoutData = sheetData.layouts[i];
      let tplData: TemplateData = configuration.templateLibrary.getById(layout.templateID);
      // console.log(tplData.borderB64);
      let rotationRad: number = -layout.rotation * Math.PI / 180;

      // because jsPdf rotation origin is bottomLeft
      let _offset = CoordUtil.rotate2D({x:0, y:-(tplData.height+_borderOffset)},-layout.rotation);
      _offset.y += (tplData.height+_borderOffset);

      doc.addImage(
        tplData.borderB64,
        'PNG',
        this.hPrintOffset + layout.x + _offset.x,
        this.vPrintOffset + layout.y - _offset.y,
        tplData.width+_borderOffset,
        tplData.height+_borderOffset,
        "labelBorder" + layout.templateID,
        'NONE',
        -layout.rotation
        );

    }
  }

  setupNewPage(doc:any, sheetData: SheetProperties): void {

    if (sheetData.title) {
      doc.setFont('helvetica');
      doc.setFontStyle('bold');
      doc.setFontSize(sheetData.title.size);
      doc.setTextColor('#004b8a');
      doc.text(sheetData.reference, this.hPrintOffset + sheetData.title.x, this.vPrintOffset + sheetData.title.y, { align: sheetData.title.align }, sheetData.title.rotation);
    }

    if (sheetData.logoPrint) {
      let rotationRad: number = sheetData.logoPrint.rotation * Math.PI / 180;
      doc.addImage(sheetData.logoPrint.base64, this.hPrintOffset + sheetData.logoPrint.x + Math.sqrt(2) * sheetData.logoPrint.height * Math.sqrt(1 - Math.cos(rotationRad)) * Math.cos(rotationRad / 2), this.vPrintOffset + sheetData.logoPrint.y - Math.sqrt(2) * sheetData.logoPrint.height * Math.sqrt(1 - Math.cos(rotationRad)) * Math.sin(rotationRad / 2), sheetData.logoPrint.width, sheetData.logoPrint.height, undefined, undefined, sheetData.logoPrint.rotation);
    }

    if (sheetData.url) {
      doc.setFont('helvetica');
      doc.setFontStyle('bold');
      doc.setFontSize(sheetData.url.size);
      doc.setTextColor('#004b8a');
      doc.text(ContextData.PDF_URL, this.hPrintOffset + sheetData.url.x, this.vPrintOffset + sheetData.url.y, { align: sheetData.url.align }, sheetData.title.rotation);
    }

    if (sheetData.date) {
      doc.setFont('helvetica');
      doc.setFontStyle('bold');
      doc.setFontSize(sheetData.date.size);
      doc.setTextColor('#004b8a');
      doc.text(sheetData.date.text, this.hPrintOffset + sheetData.date.x, this.vPrintOffset + sheetData.date.y, { align: sheetData.date.align }, sheetData.date.rotation);
    }

    if (sheetData.logo) {
      let rotationRad: number = sheetData.logo.rotation * Math.PI / 180;
      doc.addImage(sheetData.logo.base64, this.hPrintOffset + sheetData.logo.x + Math.sqrt(2) * sheetData.logo.height * Math.sqrt(1 - Math.cos(rotationRad)) * Math.cos(rotationRad / 2), this.vPrintOffset + sheetData.logo.y - Math.sqrt(2) * sheetData.logo.height * Math.sqrt(1 - Math.cos(rotationRad)) * Math.sin(rotationRad / 2), sheetData.logo.width, sheetData.logo.height, undefined, undefined, sheetData.logo.rotation);
    }
  }

  /**
		* Print offset
		*/
  public get vPrintOffset(): number {
    return this._vPrintOffset;
  }
  public get vPrintPixelsOffset(): number {
    return this.vPrintOffset * ContextData.MM_TO_PIXELS;
  }
  public set vPrintOffset(value: number) {
    this._vPrintOffset = value;
    localStorage.setItem('vPrintOffset', '' + this._vPrintOffset);
  }

  public get hPrintOffset(): number {
    return this._hPrintOffset;
  }
  public get hPrintPixelsOffset(): number {
    return this.hPrintOffset * ContextData.MM_TO_PIXELS;
  }
  public set hPrintOffset(value: number) {
    this._hPrintOffset = value;
    localStorage.setItem('hPrintOffset', '' + this._hPrintOffset);
  }
}
